import { Client } from "./Client.js";
const createClient = (repositoryNameOrEndpoint, options) => new Client(repositoryNameOrEndpoint, options);
export {
  createClient
};
//# sourceMappingURL=createClient.js.map
